/** Mirrors backend constants — keep in sync with netlify/functions/_shared/constants.mjs */

export const CHECKLIST_ITEMS = [
  { key: 'outreach',       label: 'Initial outreach completed',            responsibleParty: 'Chapter',  speakerFacing: false },
  { key: 'interest',       label: 'Speaker interest confirmed',             responsibleParty: 'Chapter',  speakerFacing: false },
  { key: 'date-confirmed', label: 'Event date and time confirmed',          responsibleParty: 'Chapter',  speakerFacing: false },
  { key: 'title',          label: 'Talk title received and approved',       responsibleParty: 'Chapter',  speakerFacing: false },
  { key: 'abstract',       label: 'Abstract received and approved',         responsibleParty: 'Chapter',  speakerFacing: false },
  { key: 'biography',      label: 'Biography received and approved',        responsibleParty: 'Speaker',  speakerFacing: true  },
  { key: 'headshot',       label: 'Headshot received and approved',         responsibleParty: 'Speaker',  speakerFacing: true  },
  { key: 'agreement-sent', label: 'Agreement sent',                         responsibleParty: 'Chapter',  speakerFacing: false },
  { key: 'agreement-rcvd', label: 'Signed agreement received',              responsibleParty: 'Speaker',  speakerFacing: true  },
  { key: 'logistics',      label: 'Event logistics confirmed with speaker',  responsibleParty: 'Chapter',  speakerFacing: false },
  { key: 'readiness',      label: 'Presentation readiness confirmed',       responsibleParty: 'Chapter',  speakerFacing: false },
  { key: 'event-done',     label: 'Event completed',                        responsibleParty: 'Chapter',  speakerFacing: false },
  { key: 'followup',       label: 'Thank-you and follow-up completed',      responsibleParty: 'Chapter',  speakerFacing: false },
];

// A Speaker's full lifecycle in one field — replaces the old separate
// Prospect entity. Potential/Contacted/Interested/Declined: pre-booking
// pipeline. Active: has at least one Engagement. Archived: manually retired.
export const SPEAKER_STATUSES = ['Potential', 'Contacted', 'Interested', 'Active', 'Declined', 'Archived'];

export const ENGAGEMENT_STATUSES = [
  'Identified', 'Contacted', 'Interested', 'Confirmed',
  'Ready', 'Completed', 'Declined', 'Cancelled',
];

export const EVENT_STATUSES = ['Draft', 'Confirmed', 'Completed', 'Cancelled'];
export const EVENT_FORMATS = ['In person', 'Virtual', 'Hybrid'];
export const AGREEMENT_STATUSES = ['Not sent', 'Sent', 'Received'];

export const COMM_TYPES = [
  'Initial outreach',
  'Invitation',
  'Confirmation',
  'Missing biography',
  'Missing abstract',
  'Missing headshot',
  'Missing agreement',
  'Request materials',
  'Missing items summary',
  'Due-date reminder',
  'Logistics confirmation',
  'Confirmation — 1 month out',
  'Confirmation — 1 week out',
  'Confirmation — day before',
  'Thank-you / follow-up',
  'Other',
];

/** Pre-booking pipeline communications — no event/agreement yet, recipient is the speaker themself. */
export const SPEAKER_COMM_TYPES = [
  'Initial outreach',
  'Follow-up nudge',
  'Interest confirmed',
  'Polite decline',
];

/** Event-level communications — addressed to every currently-engaged speaker at once. */
export const EVENT_COMM_TYPES = [
  'Logistics reminder',
  'Cancelled/rescheduled notice',
  'Call for speakers',
];

export const TIMEZONES = [
  'America/New_York',
  'America/Chicago',
  'America/Denver',
  'America/Los_Angeles',
  'America/Anchorage',
  'Pacific/Honolulu',
  'America/Puerto_Rico',
  'Europe/London',
  'Europe/Paris',
  'Asia/Tokyo',
  'Australia/Sydney',
  'UTC',
];

/** Engagement status → badge variant */
export const ENGAGEMENT_STATUS_VARIANT = {
  Identified: 'neutral',
  Contacted:  'info',
  Interested: 'info',
  Confirmed:  'primary',
  Ready:      'success',
  Completed:  'success',
  Declined:   'danger',
  Cancelled:  'neutral',
};

export const SPEAKER_STATUS_VARIANT = {
  Potential:  'neutral',
  Contacted:  'info',
  Interested: 'info',
  Active:     'success',
  Declined:   'danger',
  Archived:   'neutral',
};

export const EVENT_STATUS_VARIANT = {
  Draft:     'neutral',
  Confirmed: 'primary',
  Completed: 'success',
  Cancelled: 'danger',
};
